import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { map as __map, filter as __filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../api-configuration";
import * as i2 from "@angular/common/http";
/**
 * Search Controller
 */
class SearchControllerService extends __BaseService {
    constructor(config, http) {
        super(config, http);
    }
    /**
     * @param params The `SearchControllerService.SearchContentsUsingGETParams` containing the following parameters:
     *
     * - `revisionTag`: revisionTag
     *
     * - `q`: q
     *
     * @return OK
     */
    searchContentsUsingGETResponse(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        if (params.q != null)
            __params = __params.set('q', params.q.toString());
        let req = new HttpRequest('GET', this.rootUrl + `/api/search/contents`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `SearchControllerService.SearchContentsUsingGETParams` containing the following parameters:
     *
     * - `revisionTag`: revisionTag
     *
     * - `q`: q
     *
     * @return OK
     */
    searchContentsUsingGET(params) {
        return this.searchContentsUsingGETResponse(params).pipe(__map(_r => _r.body));
    }
    /**
     * @param params The `SearchControllerService.SearchPageTemplatesUsingGETParams` containing the following parameters:
     *
     * - `revisionTag`: revisionTag
     *
     * - `q`: q
     *
     * @return OK
     */
    searchPageTemplatesUsingGETResponse(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        if (params.q != null)
            __params = __params.set('q', params.q.toString());
        let req = new HttpRequest('GET', this.rootUrl + `/api/search/pagetemplates`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `SearchControllerService.SearchPageTemplatesUsingGETParams` containing the following parameters:
     *
     * - `revisionTag`: revisionTag
     *
     * - `q`: q
     *
     * @return OK
     */
    searchPageTemplatesUsingGET(params) {
        return this.searchPageTemplatesUsingGETResponse(params).pipe(__map(_r => _r.body));
    }
}
SearchControllerService.ngInjectableDef = i0.defineInjectable({ factory: function SearchControllerService_Factory() { return new SearchControllerService(i0.inject(i1.ApiConfiguration), i0.inject(i2.HttpClient)); }, token: SearchControllerService, providedIn: "root" });
export { SearchControllerService };
